import { render, staticRenderFns } from "./boxSpecificationExample.vue?vue&type=template&id=419f2bbd&scoped=true&"
import script from "./boxSpecificationExample.vue?vue&type=script&lang=js&"
export * from "./boxSpecificationExample.vue?vue&type=script&lang=js&"
import style0 from "./boxSpecificationExample.vue?vue&type=style&index=0&id=419f2bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f2bbd",
  null
  
)

export default component.exports